import React, { useEffect } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import { Link } from 'react-router-dom';

import {
  useQuery,
  useHttpStatus,
} from '~/commons/hooks';

import FormPwdReset from '../forms/FormPwdReset.jsx';
import AnimPending from '~/commons/components/AnimPending.jsx';

import { env, meta } from '~/commons/config';

const PagePwdReset = () => {
  const [res, req] = useHttpStatus();
  const { key } = useQuery();

  meta.set({ title: '更改密碼' });

  useEffect(() => {
    if (key) {
      req({
        method: 'post',
        url: 'api/core/password/reset/validate',
        data: { key },
      });
    }
  }, [key]);

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-4">
          {res.status === 'pending' && (
            <AnimPending />
          )}
          {(!key || res.status === 'error') && (
            <div>
              <h1 className="text-danger">
                <FA icon={faExclamationCircle} />
              </h1>
              <h3>此連結已過期</h3>
              <p>
                <Link to='/pwd-recovery'>
                  按此重發驗證碼
                </Link>
              </p>
            </div>
          )}
          {res.status === 'success' && (
            <FormPwdReset resetKey={key} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PagePwdReset;
